// Workspace switcher — chooses which of the two shells the user lives in.
//
//   "gabruz" → the full club app (Dashboard, Members, Groups, Teams,
//              Schedules, Squads, Practice, Rankings, Splits, Finance,
//              Admin, etc.). This is the default.
//   "league" → the executive-committee shell (Executive Committee,
//              Teams Management, Schedule Management, Umpiring Pool,
//              Announcements). No club-side surfaces.
//
// Access is checked in data.js `workspaceAccess` — users can only pick
// a workspace they're actually allowed into. The choice is persisted in
// localStorage so the next login lands them where they left off. A user
// with access to both can flip between them via a switcher in the
// topbar without logging out.

import React, { createContext, useContext, useEffect, useState } from "react";

const STORAGE_KEY  = "gabruz-workspace";
const WorkspaceCtx = createContext(null);
const VALID        = ["gabruz", "league", "umpire"];
export const DEFAULT_WORKSPACE = "gabruz";

function readInitial() {
  if (typeof localStorage === "undefined") return DEFAULT_WORKSPACE;
  const saved = localStorage.getItem(STORAGE_KEY);
  if (VALID.includes(saved)) return saved;
  return DEFAULT_WORKSPACE;
}

export function WorkspaceProvider({ children }) {
  const [workspace, setWorkspaceState] = useState(readInitial);

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.dataset.workspace = workspace;
    }
  }, [workspace]);

  function setWorkspace(next) {
    if (!VALID.includes(next)) return;
    setWorkspaceState(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch { /* ignore */ }
  }

  return (
    <WorkspaceCtx.Provider value={{ workspace, setWorkspace }}>
      {children}
    </WorkspaceCtx.Provider>
  );
}

export function useWorkspace() {
  const ctx = useContext(WorkspaceCtx);
  if (!ctx) throw new Error("useWorkspace must be used inside <WorkspaceProvider>");
  return ctx;
}
